import { __rest } from '../common/temp/node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import '../components/react-base/dist/_common/stitches/stitches.config.js';
import '../components/react-base/dist/StylesSSR/StylesSSR.js';
import '../components/react-base/dist/StylesSSR/NormalizeCSS.js';
import { forwardRef } from 'react';
import '../components/react-base/dist/tokens/tokens-base/properties/build/js/index.js';
import '../components/react-base/dist/common/temp/node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';
import '../components/react-base/dist/_common/hocs/styleProps/styleProps.config.js';
import '../components/react-base/dist/_common/utils/tokensVariants.utils.js';
import '../components/react-base/dist/_common/utils/buildAllBreakpointsWithGivenBreakpoints.js';
import '../components/react-base/dist/_common/utils/console.js';
import '../components/react-base/dist/_common/hooks/useHorizontalScroll.utils.js';
import '../components/react-base/dist/_common/hooks/useCarouselScroll/scroll.utils.js';
import '../components/react-base/dist/ActionButton/ActionButton.js';
import '../components/react-base/dist/Avatar/Avatar.js';
import '../components/react-base/dist/Breadcrumbs/Breadcrumbs.js';
import '../components/react-base/dist/Breadcrumbs/BreadcrumbItem/BreadcrumbItem.js';
import '../components/react-base/dist/Breadcrumbs/BreadcrumbText/BreadcrumbText.js';
import '../components/react-base/dist/Breadcrumbs/BreadcrumbSeparator/BreadcrumbSeparator.js';
import '../components/react-base/dist/Button/Button.js';
import '../components/react-base/dist/Button/Button.utils.js';
import '../components/react-base/dist/Button/ButtonLink/ButtonLink.js';
import '../components/react-base/dist/Card/Card.styles.js';
import '../components/react-base/dist/Card/CardImage/CardImage.js';
import '../components/react-base/dist/Card/CardTitle/CardTitle.js';
import '../components/react-base/dist/CarouselWrapper/CarouselWrapper.js';
import '../components/react-base/dist/Checkbox/Checkbox.js';
import '../components/react-base/dist/Chip/Chip.js';
import '../components/react-base/dist/CircularLoader/CircularLoader.js';
import '../components/react-base/dist/Clickable/Clickable.js';
import '../components/react-base/dist/ClickAwayListener/ClickAwayListener.js';
import '../components/react-base/dist/Container/Container.js';
import '../components/react-base/dist/Dialog/Dialog.js';
import { Divider as Divider$1 } from '../components/react-base/dist/Divider/Divider.js';
import '../components/react-base/dist/Drawer/Drawer.js';
import '../components/react-base/dist/DropdownMenu/DropdownMenuItem.styles.js';
import '../components/react-base/dist/Feedback/Feedback.js';
import '../components/react-base/dist/FloatingActionButton/FloatingActionButton.js';
import '../components/react-base/dist/Layout/Flex/Flex.js';
import '../components/react-base/dist/Layout/Grid/Grid.js';
import '../components/react-base/dist/Layout/GridItem/GridItem.js';
import '../components/react-base/dist/Image/Image.js';
import '../components/react-base/dist/Input/Select/Select.js';
import '../components/react-base/dist/Input/TextField/TextField.js';
import '../components/react-base/dist/Input/TextArea/TextArea.js';
import '../components/react-base/dist/Label/Label.js';
import '../components/react-base/dist/LinearBar/LinearBar.js';
import '../components/react-base/dist/Link/Link.js';
import '../components/react-base/dist/Link/LinkButton/LinkButton.js';
import '../components/react-base/dist/List/List.js';
import '../components/react-base/dist/List/ListItem/ListItem.js';
import '../components/react-base/dist/Modal/Modal.js';
import '../components/react-base/dist/Option/Option.js';
import '../components/react-base/dist/OptionsPopover/OptionsPopover.js';
import '../components/react-base/dist/Popover/Popover.js';
import '../components/react-base/dist/Radio/Radio.js';
import '../components/react-base/dist/Responsivity/hooks/ViewPort.context.js';
import '../components/react-base/dist/Responsivity/utils/mediaQueries.utils.js';
import '../components/react-base/dist/Slider/Slider.js';
import '../components/react-base/dist/Slider/SliderDrag/SliderDrag.styles.js';
import '../components/react-base/dist/SnackBar/SnackBar.js';
import '../components/react-base/dist/StylePropsWrapper/StylePropsWrapper.js';
import '../components/react-base/dist/Switch/SwitchThumb/SwitchThumb.js';
import '../components/react-base/dist/Switch/SwitchTrack/SwitchTrack.js';
import '../components/react-base/dist/Switch/SwitchIcon/SwitchIcon.js';
import '../components/react-base/dist/Switch/Switch.js';
import '../components/react-base/dist/Table/Table/Table.js';
import '../components/react-base/dist/Table/TableBody/TableBody.js';
import '../components/react-base/dist/Table/TableData/TableData.js';
import '../components/react-base/dist/Table/TableHead/TableHead.js';
import '../components/react-base/dist/Table/TableHeader/TableHeader.js';
import '../components/react-base/dist/Table/TableRow/TableRow.js';
import '../components/react-base/dist/Tabs/Tabs.js';
import '../components/react-base/dist/Tabs/TabListItem/TabListItem.js';
import '../components/react-base/dist/Tabs/contexts/TabsContext.js';
import '../components/react-base/dist/Tag/Tag.js';
import '../components/react-base/dist/Typography/Typography.js';
import '../components/react-base/dist/UISpacer/UISpacer.js';
import '../components/react-base/dist/UploadedFilesList/UploadedFilesList.js';
import '../components/react-base/dist/UploadedFilesList/UploadedFilesList.types.js';
import '../components/react-base/dist/Uploader/Uploader.js';
import '../components/react-base/dist/VisuallyHiddenInput/VisuallyHiddenInput.js';
import '../components/react-base/dist/ScreenshotCases/ScreenshotCases.js';
import '../components/react-base/dist/ScreenshotCases/ScreenshotCase.js';
import { clsx } from '../common/temp/node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js';
import { dividerWrapperStyles, dividerStyles } from './Divider.styles.js';
const Divider = forwardRef((props, ref) => {
  const {
      orientation = 'horizontal',
      weight = 'light',
      inline = false,
      modifier = 'none',
      className
    } = props,
    htmlProps = __rest(props, ["orientation", "weight", "inline", "modifier", "className"]);
  const dividerWrapperClass = dividerWrapperStyles({
    orientation,
    inline
  }).className;
  const dividerClass = dividerStyles({
    weight,
    modifier
  }).className;
  return jsx(Divider$1, Object.assign({
    ref: ref
  }, htmlProps, {
    className: clsx(dividerWrapperClass, className),
    inline: inline,
    orientation: orientation,
    customProps: {
      divider: {
        className: dividerClass
      }
    }
  }), void 0);
});
Divider.displayName = 'ReactCredPago_Divider';
export { Divider };